<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre9 sgc-14 sgc-51">Foreword</h1>
<p class="calibre1 dot1000"></p>
<p class="calibre13 ind">This book portrays the mechanics used by the 66th Armored Regiment in satisfying its basic and necessary obligation of closing with and destroying the enemy. From its baptism of fire in the mud of Flanders Fields in World War I to the triumphant march into the capital of Hitler’s defeated Reich in 1945, this is the story of the Iron Knights of the 66th Armored Regiment. The arms of the 66th proudly bear the heraldic symbol of the eldest son denoting the regiment’s preeminent status as the U.S. Army’s senior armored regiment.</p>
<p class="calibre1 ind">Story days, glory days, gory days, they are all here. And boring sections like countless noncombat road marches? These marches were not so boring after all. The message is: you must learn how to be there at the right place at the right time. The 66th exemplified their unit motto of <i>Semper in Hostes</i> (Always into the enemy) by taking advantage of those opportunities to engage and defeat the enemy.</p>
<p class="calibre1 ind">The book skeleton is fact from file—facts from numerous written accounts such as official army records and after-action reports. And more facts from more files (research done in various libraries with this unit’s historical documents). The evidence is that Gordon Blaker used them all. The meat: anecdotes by soldiers who were there. Gordon Blaker uses both written accounts from and personal interviews with numerous veterans of the 66th from commanders to tank drivers. The letters and diaries of the soldiers of 66th, both those who made it from “Benning to Berlin” as well as those of our comrades who paid the ultimate price, bring the story to life. Impossible to assemble all the personal memories. The samples used are vivid and meaningful.</p>
<p class="calibre1 ind">The book is a good stone in the pyramid of the History of Combat; “Iron Knights” is a fine story.</p>
<p class="calibre1 ind">Semper In Hostes, Iron Knights!</p>
<p class="calibre1 sgc-15">Captain James M. Burt, Congressional Medal of Honor</p>
<p class="calibre1 sgc-15">Commander, B Company, 66th Armored Regiment</p>
<p class="calibre1 sgc-15 indent18">April 1997</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword.vue?31cb3cd5